export default {
  brand: {
    name: 'PageDrop',
    tagline: '拖拽上传，即刻预览',
  },
  nav: {
    home: '首页',
    records: '生成记录',
  },
  theme: {
    light: '浅色模式',
    dark: '深色模式',
    system: '跟随系统',
  },
  lang: {
    switchTo: 'Switch to English',
  },
  auth: {
    login: '使用一方工具箱账号登录',
    logout: '退出',
    loginPromptTitle: '登录后才能上传',
    loginPromptDesc: '选择与上传文件均需登录一方工具箱账号，未登录无法选文件或上传。登录后即可拖拽上传并自动保存生成记录。',
    notNow: '暂不登录',
    loginRequiredTitle: '登录后查看生成记录',
    loginRequiredDesc: '使用一方工具箱账号统一登录，登录后可查看你的历史记录与存储额度。',
    reauth: '重新授权',
    reauthDesc: '当前授权未包含存储能力（storage scope），重新授权后即可使用上传与额度功能。',
    callbackTitle: '登录失败',
    errorPrefix: '错误信息',
    retry: '重试登录',
    backHome: '返回首页',
  },
  home: {
    heroBadge: '需求文档里的 HTML，从此不用下载',
    h1a: '把 HTML 原型',
    h1b: '变成一条链接',
    sub: '拖拽上传 HTML 及 CSS / JS / 图片等静态资源，一键生成在线预览链接，贴进需求文档、IM、邮件即可直接打开。',
    howTitle: '三步搞定',
    step1t: '拖入文件',
    step1d: '支持单个 HTML 文件，或包含 CSS / JS / 图片的原型文件夹。',
    step2t: '生成链接',
    step2d: '上传完成后自动获得一个可分享的在线预览地址。',
    step3t: '贴进文档',
    step3d: '打开链接即可查看交互原型，无需下载任何附件。',
    featTitle: '为协作而生',
    f1t: '交互式预览',
    f1d: '按原始效果渲染页面，JS 交互照常运行。',
    f2t: '完整静态资源',
    f2d: 'CSS、JS、图片、字体一应俱全，目录结构原样保留。',
    f3t: '双语与深色模式',
    f3d: '中英文界面，浅色 / 深色 / 跟随系统，手机与 PC 自适应。',
    f4t: '生成记录',
    f4d: '使用一方工具箱账号登录，每次上传自动保存为记录。',
    formats: '支持 HTML / CSS / JS / 图片 / 字体等网页资源',
  },
  dropzone: {
    hint: '拖拽 HTML 文件或整个文件夹到此处（自动包含全部子目录）',
    pickFiles: '选择文件',
    pickFolder: '选择文件夹',
    entryBadge: '入口',
    setEntry: '设为入口',
    total: '已选 {{count}} / {{all}} 个文件 · 共 {{size}}',
    autoSkipped: '已自动排除 {{count}} 个文件（.git、node_modules、非网页资源等），勾选后仍可上传',
    expandAll: '展开全部',
    collapseAll: '收起全部',
    clear: '清空',
    uploadBtn: '上传并保存到生成记录',
    updateBtn: '上传并覆盖更新',
    updateNote: '正在更新「{{name}}」：本次上传的文件将整体替换原项目文件，预览链接保持不变。',
    uploadSoon: '直传与预览服务将在下一阶段开放',
    noHtml: '勾选的文件中未发现 HTML，请至少勾选一个 .html 页面',
    noSelected: '尚未勾选任何文件，请在下方列表勾选需要上传的文件或文件夹',
    toggleFolder: '展开/收起文件夹 {{name}}',
    includeDir: '包含文件夹 {{name}}',
    includeFile: '上传文件 {{name}}',
  },
  upload: {
    checking: '正在检查存储额度…',
    uploading: '正在上传 {{name}}',
    uploadingMany: '正在并发上传 {{name}} 等 {{count}} 个文件',
    cancel: '取消上传',
    cancelled: '已取消上传。已完成上传的文件仍会占用存储额度。',
    saving: '正在保存生成记录…',
    successTitle: '上传完成，已保存记录',
    successDesc: '文件体积已计入你的存储额度，预览链接已生成，可贴进需求文档分享。',
    viewRecords: '查看生成记录',
    openPreview: '打开预览',
    uploadMore: '继续上传',
    quotaExceeded: '存储额度不足：剩余 {{remaining}}，本次还需 {{need}}。',
    buyQuota: '前往主站购买额度',
    fileTooLarge: '{{name}} 超过单文件 500MB 上限',
    uploadNotEnabled: '该应用未开通直传上传（需管理员在主站 OAuth 应用中登记 R2 桶）',
    putFailed: '{{name}} 上传失败（大小或类型与凭证不符），请重试',
    saveFailed: '记录保存失败，但文件已上传并计入额度，请稍后刷新重试。',
    updateFailed: '更新失败，但新文件已上传并计入额度，请稍后重试。',
    updateNotFound: '项目不存在或无权更新，请返回生成记录刷新后重试。',
    updateSuccessTitle: '更新完成，预览已刷新',
    updateSuccessDesc: '全部文件已覆盖、缓存已失效，打开预览即可看到最新版本。',
    backToRecords: '返回生成记录',
    updateMore: '继续更新',
    networkError: '网络错误，请重试',
    reauthNeeded: '登录状态已过期或授权不足，请重新登录',
    retry: '重试',
  },
  records: {
    title: '生成记录',
    uploadNew: '上传新项目',
    update: '更新',
    quota: '存储额度',
    quotaUsed: '已用 {{used}} / {{total}}',
    quotaRemaining: '剩余 {{size}}',
    pending: '预留中 {{size}}',
    files: '{{count}} 个文件',
    entry: '入口',
    preview: '预览',
    copyLink: '复制链接',
    copied: '已复制',
    loadFailed: '记录加载失败，请刷新重试',
    empty: '还没有生成记录',
    emptyHint: '上传第一个 HTML 原型后，这里会保存你的生成记录与预览链接。',
    goUpload: '去上传',
  },
  updatePage: {
    title: '更新项目',
    titleNamed: '更新项目：{{name}}',
    back: '返回生成记录',
    notFound: '项目不存在或无权访问',
  },
  footer: {
    slogan: '让每一次原型评审，从一条链接开始。',
    note: '<0>一方工具箱</0>子站 · 使用一方工具箱账号统一登录',
  },
  notfound: {
    title: '页面不存在',
    desc: '你访问的页面不存在或已被移除。',
    back: '返回首页',
  },
  seo: {
    homeTitle: 'PageDrop · HTML 原型在线预览',
    homeDesc:
      '拖拽上传 HTML 原型与 CSS/JS/图片资源，一键生成在线预览链接，贴进需求文档即可直接查看，无需下载附件。',
    recordsTitle: '生成记录 · PageDrop',
    recordsDesc: '查看你上传的 HTML 原型、预览链接与存储额度。',
    updateTitle: '更新项目 · PageDrop',
    notFoundTitle: '页面不存在 · PageDrop',
  },
}
